import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalize' }) // tslint:disable-line:pipe-naming
export class CapitalizePipe implements PipeTransform {
  transform(value: any) {
    const isString = typeof value === 'string' || value instanceof String;
    if (value && isString) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
    return value;
  }
}
